import React, { useEffect, useRef, useState } from "react";
import { fetchUsersOfAdmin } from "../api";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Typography,
  Box,
  Breadcrumbs,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

const tableStyles = {
  borderRadius: 3,
  boxShadow: "0 2px 16px #E6E9F4",
  overflow: "hidden",
};

const headCellStyles = {
  background: "#DBDFFE",
  color: "#353765",
  fontWeight: 700,
  fontSize: 17,
  border: "2px solid #F2F3F7",
  letterSpacing: 0.2,
  textAlign: "center",
};

const bodyCellStyles = {
  color: "#353765",
  fontWeight: 500,
  fontSize: 16,
  border: "1px solid #F2F3F7",
  padding: "18px 12px",
  background: "#fff",
  textAlign: "center",
};

const UserList = ({ onSelectUser }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    fetchUsersOfAdmin().then((data) => {
      if (data.success) setUsers(data.usersList);
      setLoading(false);
    });
  }, []);

  if (loading)
    return (
      <Box
        sx={{ width: "100%", display: "flex", justifyContent: "center", py: 5 }}
      >
        <CircularProgress />
      </Box>
    );

  return (
    <Box>
      <Breadcrumbs
        separator="/"
        aria-label="breadcrumb"
        sx={{ mb: 2, fontSize: 20, mt: 2 }}
      >
        <Typography color="text.primary" sx={{ fontWeight: 500, fontSize: 16 }}>
          Users List
        </Typography>
      </Breadcrumbs>
      <Paper elevation={0} sx={tableStyles}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={headCellStyles}>User Name</TableCell>
              <TableCell sx={headCellStyles}>User Email</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((u) => (
              <TableRow
                key={u.userId}
                sx={{
                  background: "#fff",
                  cursor: "pointer",
                  transition: "background 0.15s",
                  "&:hover td": {
                    background: "#ebedfc",
                  },
                }}
                onClick={() => onSelectUser(u)}
              >
                <TableCell sx={bodyCellStyles}>{u.name}</TableCell>
                <TableCell sx={bodyCellStyles}>{u.email}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
};

export default UserList;
